import { useMutation, useQueryClient } from "@tanstack/react-query";

import { callLcosService } from "../../data/lcosServices";
import { useAccessToken } from "../use-access-token";
import { inquiryQueryKeys } from "../use-inquiries/query-keys";
import { familyQueryKeys } from "./query-keys";
import type { FamilyRelationship } from "./types";

export const useFamilyRelationships = (familyId?: string) => {
  const { getToken } = useAccessToken();
  const queryClient = useQueryClient();

  const addFamilyRelationshipMutator = useMutation({
    mutationFn: async (payload: FamilyRelationship) =>
      familyId ? addFamilyRelationship(await getToken(), familyId, payload) : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: familyQueryKeys.base });
    }
  });

  return {
    addFamilyRelationshipMutator
  };
};

export const addFamilyRelationship = (accessToken: string, familyId: string, payload: FamilyRelationship) => {
  return callLcosService<FamilyRelationship>(accessToken, `/api/families/${familyId}/relationships`, "POST", payload);
};
